import { useState, useEffect, useRef } from 'react';
import { basePort, getUsernameJwt, headers, isExpiredJwt, renderRedirect, setTokenHeader, getJwtFromCookies, IsMbrRolePv } from "../../../module_auth/AuthService"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { ToastMessage } from "../../../component/common/Toast"
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import { plans } from "./TalentCommonUtil"
import { ServiceDisclaimerCard } from "../../common/ServiceDisclaimerCard";
import { CategorySelect } from "./CategorySelect";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faHourglassHalf, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { TALENT_IMAGE_URL_PREFIX } from "../../../Config";

export function TalentEditMypage() {
    const navigate = useNavigate();

    const { regId } = useParams();
    const [title, setTitle] = useState("");
    const [categoryCode, setCategoryCode] = useState("");
    const [priceValue, setPriceValue] = useState(0);
    const [priceUnit, setPriceUnit] = useState("HOUR");
    const [isPriceNegotiable, setIsPriceNegotiable] = useState(0);
    const [priceNote, setPriceNote] = useState("");
    const [descriptionText, setDescriptionText] = useState("");
    const [expertIntroText, setExpertIntroText] = useState("");
    const [email, setEmail] = useState("");
    const [mbrId, setMbrId] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("/");
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    const [accessToken, setAccessToken] = useState("");
    const [cityList, setCityList] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedCityId, setSelectedCityId] = useState("");
    const [serviceMode, setServiceMode] = useState("OFFLINE");
    const [nickname, setNickname] = useState("");
    const [cityName, setCityName] = useState("");
    const [updateAt, setUpdateAt] = useState("");
    const [categoryName, setCategoryName] = useState("");
    const [hits, setHits] = useState(0);
    const [mainImageUrl, setMainImageUrl] = useState(""); // 메인 이미지 (단일 문자열)
    const [detailImageUrls, setDetailImageUrls] = useState([]); // 디테일 이미지 (배열, 최대 4개)
    const [initialDetailImageCount, setInitialDetailImageCount] = useState(0);

    const [subPreviews, setSubPreviews] = useState(Array(4).fill(null));
    const [selectedPlanCode, setSelectedPlanCode] = useState("");

    const [postStartDate, setPostStartDate] = useState(null);
    const [postEndDate, setPostEndDate] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 모달 상태
    const [showMainCropModal, setShowMainCropModal] = useState(false);

    //메인이미지 및 상세이미지
    const [mainFile, setMainFile] = useState(null);
    const [isChangedMain, setIsChangedMain] = useState(false);
    const [subFiles, setSubFiles] = useState([null, null, null, null]);
    const [isChangedSub, setIsChangedSub] = useState(false);

    const [mainPreview, setMainPreview] = useState(null); // 최종 자른 이미지 미리보기 (DataURL)
    const [selectedImage, setSelectedImage] = useState(null); // 원본 이미지 (Cropper용)
    const cropperInstance = useRef(null); // Cropper 인스턴스
    // 권장 규격 (비율 계산용)
    const TARGET_WIDTH = 212;
    const TARGET_HEIGHT = 159;


    useEffect(() => {
        window.scrollTo(0, 0);
        if (getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())) {
            setRedirectUrl("/login")
            setRedirect(true)
        } else if (!IsMbrRolePv(getJwtFromCookies())) {
            setRedirectUrl("/")
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
            getCityList();
            getTalentService();
        }
    }, []);

    function getTalentService() {
        let url = basePort + '/get/talent/mypage/' + regId; // 재능 상세 API 호출
        setIsLoading(true);
        fetch(url, { method: 'GET', headers })
            .then(async response => {
                const responseBody = await response.json().catch(() => null);

                if (response.status === 404) {
                    throw new Error(responseBody?.message || responseBody?.detail || "해당 서비스를 찾을 수 없습니다.");
                }

                if (!response.ok) {
                    throw new Error(responseBody?.message || responseBody?.detail || "서버 통신 중 오류가 발생했습니다.");
                }

                return responseBody;
            })
            .then(res => {
                console.log("서버 응답 데이터:", res);
                console.log("서버 응답 데이터 이미지:", res.serviceImages);
                // --- 이미지 처리 로직 추가 ---
                if (res.serviceImages && Array.isArray(res.serviceImages)) {
                    const images = res.serviceImages;
                    console.log("images ", images)

                    // 1. 메인 이미지 찾기 (MAIN 타입 중 첫 번째)
                    const mainImgObj = images.find(img => img.imageType === "MAIN");
                    if (mainImgObj) {
                        const fullUrl = `${mainImgObj.fileDirectory}/${mainImgObj.uniqFileName}`;
                        setMainImageUrl(fullUrl);
                        setMainPreview(fullUrl);
                    }

                    // 2. 디테일 이미지 처리 (DETAIL 타입만 필터링 -> sortOrder 정렬 -> 상위 4개)
                    const details = images
                        .filter(img => img.imageType === "DETAIL")
                        .sort((a, b) => a.sortOrder - b.sortOrder)
                        .slice(0, 4);

                    // 서브 이미지 미리보기 초기화
                    const detailUrls = details.map(img => `${img.fileDirectory}/${img.uniqFileName}`);

                    const nextPreviews = Array(4).fill(null);
                    detailUrls.forEach((url, idx) => {
                        if (idx < 4) nextPreviews[idx] = url;
                    });

                    setSubPreviews(nextPreviews);
                    setInitialDetailImageCount(detailUrls.length);
                } else {
                    setInitialDetailImageCount(0);
                }

                setTitle(res.title);
                setNickname(res.nickname || "정보 없음");
                setCategoryName(res.categoryName); // 백엔드에서 코드명 대신 한글명을 보내준다고 가정
                setCategoryCode(res.categoryCode)
                setPriceValue(res.priceValue);
                setPriceUnit(res.priceUnit);
                setIsPriceNegotiable(Number(res.isPriceNegotiable) === 1 ? 1 : 0);
                setPriceNote(res.priceNote);
                setDescriptionText(res.descriptionText || "");
                setExpertIntroText(res.expertIntroText || "");
                const nextSelectedCityId = res.selectedCityId || "";
                const nextIsRemote = res.isRemote === 1;

                setSelectedCityId(nextSelectedCityId)
                if (!nextIsRemote) {
                    setServiceMode("OFFLINE");
                } else if (!nextSelectedCityId) {
                    setServiceMode("REMOTE");
                } else {
                    setServiceMode("HYBRID");
                }
                setCityName(res.cityName)
                setUpdateAt(res.updateAt);
                setHits(res.hits)
                setEmail(res.email)
                setSelectedPlanCode(res.selectedPlanCode)
                setPostStartDate(res.postStartDate)
                setPostEndDate(res.postEndDate)
            })
            .catch(error => {
                console.log(error);
                alert(error.message || "해당 서비스를 찾을 수 없습니다.");
                navigate('/talent_list_mypage');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    function getCityList() {
        let url = basePort + '/get/config'
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setCityList(response.cityEntityList)

                let cityOptions = response.cityEntityList.map(city => ({
                    value: city.id,    // 도시 객체의 'id'를 'value'로 매핑
                    label: city.cityName   // 도시 객체의 'name'을 'label'로 매핑
                }));
                setOptions(cityOptions);

            }).catch(error => console.log(error))
    }

    // 파일 선택 시 실행
    const handleMainFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // 일단 파일 정보만 저장 (파일명 표시용)
            setMainFile(file);

            // 원본 파일을 읽어 Cropper 모달에 띄움
            const reader = new FileReader();
            reader.onloadend = () => {
                if (cropperInstance.current) {
                    cropperInstance.current.destroy();
                    cropperInstance.current = null;
                }
                setSelectedImage(reader.result); // 원본 이미지 세팅
                setShowMainCropModal(true); // 모달 열기
            };
            reader.readAsDataURL(file);
        }
    };

    // 모달에서 '자르기 및 적용' 클릭 시 실행
    const handleMainCrop = () => {
        if (cropperInstance.current) {
            const croppedCanvas = cropperInstance.current.getCroppedCanvas({
                // 최종 결과물 스타일 정의 (필요시 크기 고정 가능)
                width: TARGET_WIDTH,
                height: TARGET_HEIGHT,
            });

            if (croppedCanvas) {
                // 1. 미리보기 업데이트
                const croppedDataURL = croppedCanvas.toDataURL(mainFile.type);
                setMainPreview(croppedDataURL);

                // 2. (옵션) 서버 전송용 Blob 객체 생성
                // 만약 서버가 Blob/File을 요구하면 이 처리가 필요합니다.
                croppedCanvas.toBlob((blob) => {
                    const croppedFile = new File([blob], mainFile.name, { type: mainFile.type });
                    setMainFile(croppedFile); // 최종 자른 파일로 교체
                    setIsChangedMain(true) // 메인이미지변경됨
                }, mainFile.type);

                setShowMainCropModal(false); // 모달 닫기
            }
        }
    };

    // 모달 취소 시 실행
    const closeMainCropModal = () => {
        setShowMainCropModal(false);
        setSelectedImage(null);
        // 파일을 새로 선택하려다 취소한 경우이므로, 
        // 전송용 파일만 비우고 미리보기는 기존(mainImageUrl)으로 유지하거나 
        // 이미 크롭 완료된 상태였다면 그 상태를 유지해야 합니다.
        if (!isChangedMain) {
            setMainFile(null);
            setMainPreview(mainImageUrl);
            document.getElementById("mainFileInput").value = "";
        }
    };

    // 최종 이미지 삭제 및 기존 이미지 복구
    const removeMainImage = () => {
        setMainFile(null); // 전송할 파일 객체 초기화
        setIsChangedMain(false); // 변경 상태 해제

        // 만약 기존에 저장된 원본 이미지 URL이 있다면 그것으로 복구, 없으면 null
        setMainPreview(mainImageUrl ? mainImageUrl : null);

        // input element 초기화 (동일 파일 재선택 가능하게)
        const fileInput = document.getElementById("mainFileInput");
        if (fileInput) fileInput.value = "";
    };

    const isTemporaryPreviewUrl = (url) => typeof url === "string" && (url.startsWith("blob:") || url.startsWith("data:"));

    const buildDetailImageFileName = (imagePath, index) => {
        const segments = imagePath.split("/").filter(Boolean);
        const originalName = segments[segments.length - 1];

        if (originalName) {
            return originalName;
        }

        return `detail-image-${index + 1}.jpg`;
    };

    const convertExistingImageToFile = async (imagePath, index) => {
        const response = await fetch(TALENT_IMAGE_URL_PREFIX + imagePath);

        if (!response.ok) {
            throw new Error("기존 상세 이미지를 다시 불러오지 못했습니다.");
        }

        const blob = await response.blob();
        return new File([blob], buildDetailImageFileName(imagePath, index), {
            type: blob.type || "image/jpeg"
        });
    };

    const handleSubFileChange = (e, index) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        setSubFiles((prev) => {
            const next = [...prev];
            next[index] = file;
            return next;
        });

        setSubPreviews((prev) => {
            const next = [...prev];

            if (typeof next[index] === "string" && next[index].startsWith("blob:")) {
                URL.revokeObjectURL(next[index]);
            }

            next[index] = URL.createObjectURL(file);
            return next;
        });

        setIsChangedSub(true);

        // allow choosing the same file again
        e.target.value = "";
    };

    const clickSubmit = async (event) => {
        event.preventDefault();

        const normalizedIsRemote = serviceMode === "OFFLINE" ? 0 : 1;
        const normalizedSelectedCityId = serviceMode === "REMOTE" ? "" : selectedCityId;

        if (isSubmitting) {
            return;
        }

        // 1. 데이터 검증: 새 파일도 없고, 기존에 저장된 이미지 URL도 없는 경우에만 에러
        if (!mainFile && !mainImageUrl) {
            fadeOutToast("대표 이미지는 필수입니다.");
            return;
        }

        try {
            setIsSubmitting(true);

            // 2. FormData 생성 (파일 전송을 위해 필수)
            const formData = new FormData();

            // 3. 메인 이미지 추가 (수정한 경우에만 전송)
            if (mainFile) {
                formData.append("MainFile", mainFile);
            }

            // 4. 상세 이미지는 현재 화면 슬롯 상태 기준으로 전체를 다시 구성해서 전송
            const detailFilesToUpload = await Promise.all(
                subPreviews.map(async (preview, index) => {
                    if (subFiles[index]) {
                        return subFiles[index];
                    }

                    if (preview && !isTemporaryPreviewUrl(preview)) {
                        return convertExistingImageToFile(preview, index);
                    }

                    return null;
                })
            );

            detailFilesToUpload.forEach((file) => {
                if (file) {
                    formData.append("SubFiles", file);
                }
            });

            const hasAnyDetailImage = detailFilesToUpload.some((file) => file !== null);
            const clearDetailImages = initialDetailImageCount > 0 && !hasAnyDetailImage;

            // 5. JSON 데이터 추가 (백엔드 @RequestPart("JsonStr") 대응)
            const talentDto = {
                title: title,
                categoryCode: categoryCode,
                priceValue: Number(priceValue),
                priceUnit: priceUnit,
                isPriceNegotiable: isPriceNegotiable,
                priceNote: priceNote,
                descriptionText: descriptionText,
                expertIntroText: expertIntroText,
                email: email,
                selectedCityId: normalizedSelectedCityId,
                isRemote: normalizedIsRemote,
                clearDetailImages: clearDetailImages
            };
            formData.append("JsonStr", JSON.stringify(talentDto));

            // 6. 인증 헤더 설정
            setTokenHeader(getJwtFromCookies());

            // 7. 서버 전송 (fetch)
            const uploadHeaders = { ...headers };
            delete uploadHeaders['Content-Type'];

            const response = await fetch(basePort + '/update/talent/' + regId, {
                method: 'POST',
                headers: uploadHeaders,
                body: formData
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            if (data.validRequest) {
                fadeOutToast("재능서비스가 성공적으로 수정되었습니다.");
                setTimeout(() => {
                    navigate("/talent_mypage/" + regId);
                }, 3000);
                return;
            }

            fadeOutToast(data.validationMessage || "재능서비스 등록 실패");
        } catch (error) {
            console.error("Error:", error);
            fadeOutToast(error.message || "서버 통신 중 오류가 발생했습니다.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const fadeOutToast = (msg) => {
        setShowToast(true);
        setMsgToast(msg);
        setTimeout(() => setShowToast(false), 3000);
    };

    const removeSubImage = (index) => {
        // 1. 파일 객체 제거
        const newFiles = [...subFiles];
        newFiles[index] = null;
        setSubFiles(newFiles);

        // 2. 미리보기 URL 제거
        const newPreviews = [...subPreviews];
        newPreviews[index] = null;
        setSubPreviews(newPreviews);

        // 3. input 엘리먼트 값 초기화 (같은 파일을 다시 선택할 수 있도록)
        const fileInput = document.getElementById(`subFileInput-${index}`);
        if (fileInput) {
            fileInput.value = "";
        }

        // 4. (선택사항) 서버에서 가져온 기존 이미지를 삭제 목록에 추가하는 로직이 필요하다면 여기에 작성
        console.log(`${index + 1}번 이미지 삭제됨`);
    };

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', position: 'relative' }}>
            {renderRedirect(redirect, redirectUrl)}
            <main className="page landing-page" style={{ opacity: isLoading ? 0.45 : 1, pointerEvents: isLoading ? 'none' : 'auto' }}>
                <section className="container" style={{ paddingTop: '100px', paddingBottom: '80px' }}>

                    {/* 상단 헤더 & 브레드크럼 */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 bg-transparent">
                                <li className="breadcrumb-item text-muted">마이페이지</li>
                                <li className="breadcrumb-item active text-muted">재능 서비스 수정</li>
                            </ol>
                        </nav>
                    </div>

                    <div className="card border-0 shadow-sm overflow-hidden" style={{ borderRadius: '15px' }}>
                        <div className="card-header bg-white border-bottom p-4">
                            <h4 className="mb-0 fw-bold"><i className="bi bi-pencil-square me-2 text-primary"></i>서비스 정보</h4>
                            <p className="text-muted small mb-0 mt-1">고객에게 제공할 서비스 정보를 상세히 작성해 주세요.</p>
                        </div>

                        <div className="card-body p-4 p-md-5">
                            {/* 1. 기본 정보 섹션 */}
                            <div className="section-group mb-5">
                                <h5 className="fw-bold mb-4 border-start border-4 border-primary ps-3">기본 정보</h5>
                                <div className="mb-4">
                                    <label className="form-label fw-semibold text-secondary">서비스 제목</label>
                                    <input className="form-control form-control-lg border-2 shadow-none" type="text"
                                        value={title} onChange={(e) => setTitle(e.target.value)}
                                        placeholder="예: 10년 경력의 비즈니스 번역 서비스" style={{ fontSize: '1.1rem' }} />
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">진행 방식</label>
                                        <div className="border rounded-3 px-3 py-2 bg-white">
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="serviceMode"
                                                    id="serviceModeOffline"
                                                    checked={serviceMode === "OFFLINE"}
                                                    onChange={() => setServiceMode("OFFLINE")}
                                                />
                                                <label className="form-check-label text-secondary" htmlFor="serviceModeOffline">
                                                    대면
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="serviceMode"
                                                    id="serviceModeRemote"
                                                    checked={serviceMode === "REMOTE"}
                                                    onChange={() => setServiceMode("REMOTE")}
                                                />
                                                <label className="form-check-label text-secondary" htmlFor="serviceModeRemote">
                                                    온라인/원격
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="serviceMode"
                                                    id="serviceModeHybrid"
                                                    checked={serviceMode === "HYBRID"}
                                                    onChange={() => setServiceMode("HYBRID")}
                                                />
                                                <label className="form-check-label text-secondary" htmlFor="serviceModeHybrid">
                                                    하이브리드(대면/온라인)
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">활동 도시</label>
                                        <select
                                            className="form-select"
                                            value={selectedCityId}
                                            disabled={serviceMode === "REMOTE"}
                                            onChange={(e) => setSelectedCityId(e.target.value)}
                                        >
                                            <option value="">도시 선택</option>
                                            {options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                        </select>
                                        {serviceMode === "REMOTE" && (
                                            <div className="form-text text-muted mt-2">
                                                온라인/원격 선택 시 활동 도시는 비활성화되며, 현재 보이는 도시값은 저장 시 초기화됩니다.
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="row">
                                    <CategorySelect value={categoryCode} onChange={setCategoryCode} />
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">가격 설정 (유로)</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-2 border-end-0">€</span>
                                            <input className="form-control border-2 shadow-none" type="number" value={priceValue} onChange={(e) => setPriceValue(e.target.value)} />
                                            <select className="form-select border-2 shadow-none" value={priceUnit} onChange={(e) => setPriceUnit(e.target.value)}>
                                                <option value="HOUR">시간당</option>
                                                <option value="ONCE">회당</option>
                                                <option value="DAY">일당</option>
                                            </select>
                                        </div>
                                        <div className="form-check mt-3">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="isPriceNegotiableCheckbox"
                                                checked={isPriceNegotiable === 1}
                                                onChange={(e) => setIsPriceNegotiable(e.target.checked ? 1 : 0)}
                                            />
                                            <label className="form-check-label text-secondary" htmlFor="isPriceNegotiableCheckbox">
                                                가격 협의
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">노출 플랜</label>
                                        <select
                                            className="form-select border-2 shadow-none"
                                            value={selectedPlanCode}
                                            onChange={(e) => setSelectedPlanCode(e.target.value)}
                                            // [핵심] 수정 모드일 때는 선택 불가 처리
                                            disabled
                                            style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                                        >
                                            <option value="">플랜 선택</option>
                                            {plans.map((plan, index) => (
                                                <option key={index} value={plan.code}>
                                                    {plan.title} ({plan.price === "0원" ? "무료" : plan.price})
                                                </option>
                                            ))}
                                        </select>

                                        {/* 수정 모드일 때만 보여주는 안내 문구 */}
                                        <div className="mt-1 small text-danger">
                                            <i className="bi bi-exclamation-triangle-fill me-1"></i>
                                            등록된 플랜은 수정할 수 없습니다. 변경을 원하시면 고객센터로 문의해 주세요.
                                        </div>
                                    </div>
                                    {/* [신규 추가] 서비스 기간 컬럼 */}
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">서비스 제공 기간</label>
                                        <div
                                            className="form-control border-2 d-flex align-items-center"
                                            style={{
                                                backgroundColor: '#f8f9fa',
                                                minHeight: '38px',
                                                color: (!postStartDate || !postEndDate) ? '#6c757d' : '#212529'
                                            }}
                                        >
                                            {!postStartDate ? (
                                                /* 데이터가 없을 때 (검수 중) */
                                                <div className="text-muted d-flex align-items-center">
                                                    <FontAwesomeIcon icon={faHourglassHalf} className="me-2" />
                                                    <span className="fw-normal">검수 진행 중 (승인 후 기간이 표시됩니다)</span>
                                                </div>
                                            ) : (
                                                /* 데이터가 있을 때 (날짜 표시) */
                                                <div className="d-flex align-items-center" style={{ color: '#212529' }}>
                                                    <FontAwesomeIcon icon={faCalendarCheck} className="me-2 text-primary" />
                                                    <span className="fw-normal">{postStartDate}</span>

                                                    {/* 물결(~) 대신 화살표 아이콘 사용 */}
                                                    <FontAwesomeIcon icon={faArrowRight} className="mx-3 text-secondary" style={{ fontSize: '0.8rem' }} />

                                                    <span className="fw-normal">{postEndDate}</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="mt-1 small text-muted">
                                            {(!postStartDate || !postEndDate)
                                                ? "운영진 확인 후 서비스 시작일이 확정됩니다."
                                                : "해당 기간 동안 서비스가 노출됩니다."}
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="section-group mb-5 pt-4 border-top">
                                <h5 className="fw-bold mb-3 border-start border-4 border-info ps-3">대표 이미지 수정</h5>
                                <div className="p-4 border rounded-3 bg-light">
                                    <div className="row align-items-center">
                                        {/* 왼쪽: 미리보기 및 직접 클릭 수정 영역 */}
                                        <div className="col-md-5 col-lg-4 d-flex justify-content-center">
                                            {/* 미리보기 및 직접 클릭 수정 영역 */}
                                            <div
                                                className="position-relative border rounded-3 bg-white shadow-sm overflow-hidden"
                                                style={{
                                                    width: '212px',
                                                    height: '159px',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s'
                                                }}
                                                onClick={() => document.getElementById('mainFileInput').click()}
                                            >
                                                {mainPreview ? (
                                                    <>
                                                        <img
                                                            /* 중요: mainPreview가 'data:'로 시작하면 크롭된 이미지이므로 그대로 사용, 
                                                               아니면 서버 저장 이미지이므로 베이스 경로를 붙임 
                                                            */
                                                            src={mainPreview.startsWith('data:')
                                                                ? mainPreview
                                                                : TALENT_IMAGE_URL_PREFIX + mainPreview}
                                                            alt="Main Preview"
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        />
                                                        {/* 이미지 위 오버레이 */}
                                                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-25 opacity-0 hover-opacity-100"
                                                            style={{ transition: 'opacity 0.2s' }}>
                                                            <span className="badge bg-dark px-3 py-2">이미지 변경</span>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="text-center p-3 d-flex flex-column align-items-center justify-content-center h-100">
                                                        <i className="bi bi-plus-circle text-muted display-6"></i>
                                                        <div className="small text-muted mt-2">사진을 등록해주세요</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* 오른쪽: 설명 및 상태 정보 */}
                                        <div className="col-md-7 col-lg-8 mt-3 mt-md-0">
                                            <div className="mb-3">
                                                <label className="form-label fw-bold mb-1" htmlFor="mainFileInput">대표 썸네일 교체</label>
                                                <input
                                                    id="mainFileInput"
                                                    className="form-control form-control-sm border-2"
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleMainFileChange}
                                                    style={{ display: 'none' }} // 실제 input은 숨기고 미리보기를 클릭하게 유도
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-info btn-sm d-block mb-2"
                                                    onClick={() => document.getElementById('mainFileInput').click()}
                                                >
                                                    <i className="bi bi-camera me-1"></i> 파일 선택하기
                                                </button>
                                                <p className="small text-secondary mb-0">
                                                    * 권장 사이즈: 212 × 159 px (4:3 비율)<br />
                                                    * 대표 이미지는 검색 결과와 목록에 최우선으로 노출됩니다.
                                                </p>
                                            </div>

                                            {/* 변경된 파일이 있을 경우에만 표시되는 뱃지 */}
                                            {mainFile && (
                                                <div className="d-flex align-items-center bg-white p-2 border rounded-pill shadow-sm animate__animated animate__fadeIn" style={{ width: 'fit-content' }}>
                                                    <span className="text-info small fw-bold ms-2 me-3">
                                                        <i className="bi bi-check-circle-fill me-1"></i> {mainFile.name}
                                                    </span>
                                                    <button
                                                        type="button"
                                                        className="btn btn-xs btn-danger rounded-circle p-0"
                                                        style={{ width: '20px', height: '20px', lineHeight: '1' }}
                                                        onClick={removeMainImage}
                                                        title="변경 취소"
                                                    >
                                                        <i className="bi bi-x small"></i>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 대표 이미지 Cropper 모달 */}
                            {showMainCropModal && (
                                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055 }}>
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content shadow-lg border-0">
                                            <div className="modal-header bg-primary text-white">
                                                <h5 className="modal-title fw-bold">대표 이미지 영역 선택</h5>
                                                <button type="button" className="btn-close btn-close-white" onClick={closeMainCropModal}></button>
                                            </div>
                                            <div className="modal-body p-0 text-center bg-black" style={{ minHeight: '400px' }}>
                                                {selectedImage && (
                                                    <img
                                                        src={selectedImage}
                                                        alt="To be cropped"
                                                        ref={(el) => {
                                                            if (el && !cropperInstance.current) {
                                                                cropperInstance.current = new Cropper(el, {
                                                                    // 가장 중요한 부분: 212x159 비율 고정
                                                                    aspectRatio: TARGET_WIDTH / TARGET_HEIGHT,
                                                                    viewMode: 1, // 이미지가 캔버스 밖으로 나가지 않게 함
                                                                    dragMode: 'move', // 배경 이미지를 이동 가능하게 함
                                                                    autoCropArea: 1, // 처음에 꽉 차게 지정
                                                                    restore: false,
                                                                    guides: true,
                                                                    center: true,
                                                                    highlight: false,
                                                                    cropBoxMovable: true,
                                                                    cropBoxResizable: true,
                                                                    toggleDragModeOnDblclick: false,
                                                                });
                                                            }
                                                        }}
                                                        style={{ maxWidth: "100%", maxHeight: "500px" }}
                                                    />
                                                )}
                                            </div>
                                            <div className="modal-footer bg-light">
                                                <div className="text-muted small me-auto">마우스로 드래그하여 원하는 영역을 맞춰주세요.</div>
                                                <button type="button" className="btn btn-secondary" onClick={closeMainCropModal}>취소</button>
                                                <button type="button" className="btn btn-primary fw-bold" onClick={handleMainCrop}>이 영역 사용하기</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* 3. 상세 설명 섹션 */}
                            <div className="section-group mb-5 pt-4 border-top">
                                <h5 className="fw-bold mb-4 border-start border-4 border-warning ps-3">서비스 상세 내용</h5>
                                <div className="mb-5 pb-3">
                                    <label className="form-label fw-semibold">서비스 상세 설명</label>
                                    <ReactQuill theme="snow" value={descriptionText} onChange={setDescriptionText} style={{ height: '300px', marginBottom: '70px' }} />
                                </div>
                                {/* 2. 상세 이미지 섹션 (상세 설명 바로 아래 배치) */}
                                <div className="section-group mb-5 mt-5 pt-5 pt-md-2">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <h5 className="fw-bold mb-0 border-start border-4 border-info ps-3">서비스 상세 이미지</h5>
                                        <span className="badge bg-light text-dark border px-3">최대 4장</span>
                                    </div>

                                    <div className="p-4 border rounded-3 bg-white">
                                        <p className="text-muted small mb-4">
                                            <i className="bi bi-info-circle me-1"></i> 서비스의 퀄리티를 보여줄 수 있는 결과물이나 작업 과정 사진을 등록해주세요.
                                        </p>

                                        <div className="row g-3">
                                            {Array.from({ length: 4 }).map((_, index) => {
                                                const hasFile = subFiles[index] || subPreviews[index]; // 새 파일 또는 기존 미리보기 존재 여부

                                                return (
                                                    <div key={index} className="col-6 col-sm-4 col-md-3">
                                                        <div
                                                            className={`position-relative border rounded-3 d-flex align-items-center justify-content-center overflow-hidden ${!hasFile ? 'border-dashed bg-light' : ''}`}
                                                            style={{
                                                                aspectRatio: '1 / 1',
                                                                cursor: 'pointer',
                                                                borderStyle: hasFile ? 'solid' : 'dashed',
                                                                borderWidth: '2px'
                                                            }}
                                                            onClick={() => !hasFile && document.getElementById(`subFileInput-${index}`).click()}
                                                        >
                                                            {hasFile ? (
                                                                <>
                                                                    <img
                                                                        src={
                                                                            isTemporaryPreviewUrl(subPreviews[index])
                                                                                ? subPreviews[index]
                                                                                : TALENT_IMAGE_URL_PREFIX + (subPreviews[index] || "")
                                                                        }
                                                                        alt={`Sub ${index + 1}`}
                                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                    />
                                                                    {/* 이미지 조작 오버레이 */}
                                                                    <div className="position-absolute top-0 end-0 m-1">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-danger btn-sm rounded-circle p-1 shadow-sm"
                                                                            style={{ width: '24px', height: '24px', lineHeight: '1' }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation(); // 부모 클릭 이벤트 방지
                                                                                removeSubImage(index);
                                                                            }}
                                                                        >
                                                                            <i className="bi bi-x"></i>
                                                                        </button>
                                                                    </div>
                                                                    <div
                                                                        className="position-absolute bottom-0 start-0 w-100 bg-dark bg-opacity-50 text-white text-center py-1 small"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            document.getElementById(`subFileInput-${index}`).click();
                                                                        }}
                                                                    >
                                                                        교체
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="text-center text-muted">
                                                                    <i className="bi bi-plus-lg d-block mb-1"></i>
                                                                    <span className="smaller">추가</span>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* 실제 Hidden Input */}
                                                        <input
                                                            id={`subFileInput-${index}`}
                                                            type="file"
                                                            accept="image/*"
                                                            style={{ display: 'none' }}
                                                            onChange={(e) => handleSubFileChange(e, index)}
                                                        />

                                                        {/* 파일명 표시 (새로 선택된 경우만) */}
                                                        {subFiles[index] && (
                                                            <div className="text-truncate mt-1 small text-primary fw-bold" style={{ fontSize: '11px' }}>
                                                                {subFiles[index].name}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="section-group mb-5 mt-5">
                                {/* 헤더 부분: 상세 이미지 섹션과 동일한 스타일 적용 */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="fw-bold mb-0 border-start border-4 border-warning ps-3">전문가 소개</h5>
                                    {/* <span className="badge bg-light text-dark border fw-normal">선택 사항</span> */}
                                </div>

                                <div className="mb-4">
                                    {/* 에디터 영역 */}
                                    <ReactQuill
                                        theme="snow"
                                        value={expertIntroText}
                                        onChange={setExpertIntroText}
                                        placeholder="전문가님의 경력이나 강점을 자유롭게 소개해 주세요."
                                        style={{ height: '250px', marginBottom: '50px' }}
                                    />
                                </div>
                            </div>

                            {/* 4. 커뮤니케이션 채널 (디자인 카드) */}
                            <div
                                className="card border rounded-4 shadow-sm mb-5 bg-white"
                                style={{ marginTop: '75px' }} // 원하는 픽셀값으로 미세 조정
                            >
                                <div className="card-body p-4">
                                    <h5 className="fw-bold mb-4 text-dark">
                                        <i className="bi bi-headset me-2 text-primary"></i>커뮤니케이션 채널
                                    </h5>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="small fw-bold text-muted">이메일 주소</label>
                                            <div className="input-group">
                                                <span className="input-group-text border-0 bg-secondary text-white"><i className="bi bi-envelope"></i></span>
                                                <input className="form-control border bg-light shadow-none" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="contact@email.com" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ServiceDisclaimerCard />

                            {/* 등록 버튼 */}
                            <div className="text-center pt-4 mb-5">
                                <div className="d-flex align-items-center justify-content-center gap-3">
                                    {/* 취소하기 버튼: 이전 페이지(상세 보기)로 돌아감 */}
                                    <button
                                        className="btn btn-outline-danger px-4 py-2 shadow-sm d-inline-flex align-items-center justify-content-center"
                                        style={{
                                            borderRadius: '8px',
                                            fontWeight: '600',
                                            fontSize: '1rem',
                                            minWidth: '120px'
                                        }}
                                        type="button"
                                        disabled={isSubmitting}
                                        onClick={() => navigate('/talent_mypage/' + regId)} // 목록 페이지 경로로 이동
                                    >
                                        <i className="bi bi-x-circle me-2"></i>
                                        <span>취소하기</span>
                                    </button>

                                    {/* 저장 버튼: 수정 완료 로직 실행 */}
                                    <button
                                        className="btn btn-primary px-4 py-2 shadow-sm d-inline-flex align-items-center justify-content-center"
                                        style={{
                                            borderRadius: '8px',
                                            fontWeight: '600',
                                            fontSize: '1rem',
                                            minWidth: '120px'
                                        }}
                                        type="button"
                                        disabled={isSubmitting}
                                        onClick={clickSubmit}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                <span>수정 중...</span>
                                            </>
                                        ) : (
                                            <>
                                                <i className="bi bi-check2-circle me-2"></i>
                                                <span>수정 완료</span>
                                            </>
                                        )}
                                    </button>
                                </div>

                                <p className="text-muted small mt-4">
                                    <i className="bi bi-info-circle me-1"></i>
                                    수정된 내용은 운영진 검수 후에 최종 반영될 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <ToastMessage show={showToast} msg={msgToast} />
            </main>
            {isLoading && (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(128, 128, 128, 0.22)',
                        zIndex: 1050
                    }}
                >
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </div>
    );
}